import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Layout from './components/Layout';
import BarbersReport from './barbersReport/barbersReport';
import { resetReports } from './actions';
import Filters from './filters/FiltersContainer';
import BarberFilter from './barbersReport/barberFilterContainer';
import ServiceCategoryFilter from './filters/ServiceCategoryFilter';
import ExportableReport from './ExportableReport';
import resetFiltersHoc from './hoc/resetFiltersHoc';

class BarberReports extends Component {
  componentWillUnmount() {
    this.props.resetReports();
  }

  render() {
    return (
      <Layout title="Sales - Services">
        <Filters
          csv={this.props.downloadCsv}
          disableBarberFilter
          showCsvExport={this.props.canLoadReport}
        >
          <div className="c-form-input-group__item u-visible-for-large-and-up">
            <div className="c-label u-ml--">
              Filter by barber
            </div>
            <BarberFilter />
          </div>
          <ServiceCategoryFilter
            removeFilters={[]}
          />
        </Filters>
        <ExportableReport
          canLoadReport={this.props.canLoadReport}
          name="sales-services-report"
          label="Sales - Services"
        >
          <BarbersReport />
        </ExportableReport>
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  shop: state.auth.shop,
});

const mapDispatchToProps = {
  resetReports,
};

BarberReports.propTypes = {
  resetReports: PropTypes.func.isRequired,
  canLoadReport: PropTypes.bool.isRequired,
  downloadCsv: PropTypes.func.isRequired,
};

export default compose(
  resetFiltersHoc,
  connect(
    mapStateToProps,
    mapDispatchToProps
))(BarberReports);
